export function getFileIcon(mimeType?: string): string {
  if (!mimeType) return "file";
  if (mimeType.startsWith("image/")) return "file-image";
  if (mimeType.startsWith("video/")) return "file-video";
  if (mimeType.startsWith("audio/")) return "file-music";
  if (mimeType.includes("pdf")) return "file-pdf-box";
  if (mimeType.includes("word") || mimeType.includes("document"))
    return "file-word";
  if (mimeType.includes("excel") || mimeType.includes("spreadsheet"))
    return "file-excel";
  if (mimeType.includes("powerpoint") || mimeType.includes("presentation"))
    return "file-powerpoint";
  if (mimeType.includes("zip") || mimeType.includes("compressed"))
    return "folder-zip";
  return "file";
}
